{
    "AuthoriseButton_Title": "Autorisieren Sie",
    "PreAuthoriseButton_Title": "Vorautorisierung",
    "Authentication_PreAuthorisation_Successful": "Vorautorisiert",
    "Authentication_Successful": "Erteilte Genehmigung",
    "Authentication_Failed": "Das Genehmigungsverfahren ist fehlgeschlagen.",
    "Authentication_Authenticated": "Dieser Telefonieserver wurde bereits autorisiert.",
    "Authentication_Status_Title": "Zulassungsstatus",
    "Authentication_Status_Warning": "Es gibt eine Warnung für diese Autorisierung, Sie können versuchen, sie erneut zu autorisieren, um das Problem zu beheben.",
    "Authentication_Status_Warning_Range_30100_30199": "Autorisierung erfolgreich, aber es wurde ein Problem bei der Kommunikation mit MS Teams festgestellt. Bitte kontaktieren Sie den Akixi-Kundensupport.",
    "Authentication_Status_Warning_Range_30200_30299": "Autorisierung erfolgreich, aber es wurde ein Problem bei der Synchronisierung mit MS Teams festgestellt. Bitte kontaktieren Sie den Akixi-Kundensupport.",
    "NAME": "OAuthButton"
}